const BlockTitle = ({ title }) => {
    return (
        <h1>{title}</h1>
    )
}

export default BlockTitle